export default "__VITE_ASSET__KA$rGRz___"